import type { GuestAddress } from '@branditdev/mf-types'

type PostalAddress = Partial<Pick<GuestAddress, 'zip_code' | 'country_code' | 'country'>>

export const US_ZIP_CODE_MESSAGE = 'Enter a 5-digit ZIP code or ZIP+4, for example 02108 or 02108-1234.'

const isUsCountry = (country: string | null | undefined) =>
  ['US', 'USA', 'UNITED STATES', 'UNITED STATES OF AMERICA'].includes(country?.trim().toUpperCase() ?? '')

export const normalizeShippingAddressPostalCode = <T extends PostalAddress>(address: T): T => {
  if (typeof address.zip_code !== 'string' || !isUsCountry(address.country_code ?? address.country)) return address

  const zip = address.zip_code.trim()
  // Only insert a separator for exactly nine digits; never salvage malformed input.
  return { ...address, zip_code: /^[0-9]{9}$/.test(zip) ? `${zip.slice(0, 5)}-${zip.slice(5)}` : zip }
}

export const validateShippingPostalCode = (value: string | null | undefined, address: PostalAddress) => {
  if (!isUsCountry(address.country_code ?? address.country)) return true

  const { zip_code: zip } = normalizeShippingAddressPostalCode({ ...address, zip_code: value })
  return (typeof zip === 'string' && /^[0-9]{5}(?:-[0-9]{4})?$/.test(zip)) || US_ZIP_CODE_MESSAGE
}
